import { render } from "./Instagram.vue?vue&type=template&id=1f8f8478"
const script = {}
script.render = render

export default script